import { useState } from "react";
import { useForm } from "react-hook-form";
import dayjs from "dayjs";

import { Button, Modal } from "@pentabd/ui";

import {
  ErrorModal,
  InputDateControllerVertical,
  InputTextVertical,
  SuccessModal,
} from "@components";
import { useSingleSoftwareMaintenanceHistory } from "@hooks/inventory/softwareInventory/useSingleSoftwareMaintenanceHistory";

import useActionCreator from "@redux/hooks/useActionCreator";

import { createSingleSoftwareMaintenanceHistory } from "@api/inventory/software";

interface SoftwareHistoryModalPropsTypes {
  openModal: boolean;
  closeModal: () => void;
  historyId: number | null;
  id: number | string;
}

export default function SoftwareHistoryModal({
  openModal,
  closeModal,
  historyId,
  id,
}: SoftwareHistoryModalPropsTypes) {
  const { fetchSoftwareInventory } = useActionCreator();

  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean>(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);

  const { singleData } = useSingleSoftwareMaintenanceHistory(id, historyId);

  const {
    control,
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    values: historyId ? (singleData as any) : {},
  });

  const createSuccessAction = () => {
    setIsSuccessModalOpen(false);
    fetchSoftwareInventory(id);
  };

  const closeErrorModal = () => {
    setIsErrorModalOpen(false);
  };

  const onSubmit = async (data: any) => {
    try {
      const resData = await createSingleSoftwareMaintenanceHistory(id, data);

      if (resData?.status === "SUCCESS") {
        setIsSuccessModalOpen(true);
        reset();
      }
      closeModal();
    } catch (error) {
      setIsErrorModalOpen(true);
    }
  };

  return (
    <>
      {isSuccessModalOpen && (
        <SuccessModal
          isModalOpen={isSuccessModalOpen}
          action={createSuccessAction}
        />
      )}
      {isErrorModalOpen && (
        <ErrorModal
          isModalOpen={isErrorModalOpen}
          closeModal={closeErrorModal}
        />
      )}
      <Modal
        isOpen={openModal}
        portal
        overlay={openModal}
        closeAble
        onClose={closeModal}
      >
        <div className="software_maintenance_history_modal">
          <form className="container" onSubmit={handleSubmit(onSubmit)}>
            <div className="p-10 w-100 d-flex flex-column gap-6 ">
              <InputTextVertical
                label="SOFTWARE_INVENTORY.SOFTWARE_HISTORY.FORM.PARTY_NAME"
                name="partyName"
                register={{ ...register("partyName") }}
                disabled
              />

              <InputDateControllerVertical
                label="SOFTWARE_INVENTORY.SOFTWARE_HISTORY.FORM.SIGN_OFF_DATE"
                control={control}
                name="maintenanceContactSignOffDate"
                register={register}
                disabled
              />

              <InputDateControllerVertical
                label="SOFTWARE_INVENTORY.SOFTWARE_HISTORY.FORM.EXPIRY_DATE"
                control={control}
                name="maintenanceContactExpiryDate"
                register={register("maintenanceContactExpiryDate", {
                  required: "expiry date is required",
                })}
                minimumDate={dayjs().add(1, "day")}
                errors={errors}
                required
              />

              <div className="text-end col-12">
                <Button fill="outline" type="light" size="sm" htmlType="submit">
                  save
                </Button>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
}
